"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _trim = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/trim"));
var _react = require("react");
/**
 * A useEffect based hook that executes the `callback`
 * when a window event of type `eventType` is dispatched.
 * Removes this listener when component unmounts.
 *
 * @param  {String} eventType - event name to listen to
 * @param {Function} callback - event handler function
 *
 * @example
 *
 * const Listener = () => {
 *   useWindowEventCallback('help-portal-loaded', (event) => { //handle event });
 *   return;
 * }
 */
var useWindowEventCallback = function useWindowEventCallback(eventType, callback) {
  (0, _react.useEffect)(function () {
    var _eventType$trim;
    if (typeof callback !== 'function' || !(eventType !== null && eventType !== void 0 && (_eventType$trim = (0, _trim["default"])(eventType)) !== null && _eventType$trim !== void 0 && _eventType$trim.call(eventType))) {
      return function () {};
    }
    window.addEventListener(eventType, callback);
    return function () {
      window.removeEventListener(eventType, callback);
    };
  }, [callback, eventType]);
};
var _default = exports["default"] = useWindowEventCallback;